"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultExperimentsProvider = exports.createExperimentsProvider = exports.ExperimentsContext = void 0;
var react_1 = __importStar(require("react"));
var function_1 = require("fp-ts/es6/function");
var O = __importStar(require("fp-ts/es6/Option"));
var experiments_query_param_init_1 = require("./init/experiments_query_param_init");
var experiments_local_storage_cache_1 = require("./cache/experiments_local_storage_cache");
exports.ExperimentsContext = react_1.default.createContext({
    getTreatment: function (featureKey) { return 'C'; },
});
var createExperimentsProvider = function (init, cache) {
    return function ExperimentsProvider(props) {
        var handleResult = function (result) {
            result.experiments.map(function (e) {
                cache.put(result.principal, e);
            });
        };
        (0, react_1.useEffect)(function () {
            // Since this is async, we do not guarantee that the values are ready on the first get.
            // The cached values will likely be loaded first.
            // This is intentional, we do not want the app to block for the experiments to load.
            init(props.principal)
                .catch(function () { return null; })
                .then(function (result) {
                if (result) {
                    handleResult(result);
                }
            });
        }, []);
        var getTreatment = function (featureKey) {
            return (0, function_1.pipe)(cache.get(props.principal, featureKey), O.map(function (e) { return e.treatment; }), O.getOrElse(function () { return 'C'; }));
        };
        return (react_1.default.createElement(exports.ExperimentsContext.Provider, { value: {
                getTreatment: getTreatment,
            } }, props.children));
    };
};
exports.createExperimentsProvider = createExperimentsProvider;
exports.DefaultExperimentsProvider = (0, exports.createExperimentsProvider)(experiments_query_param_init_1.queryParamExperimentsInit, experiments_local_storage_cache_1.LocalStorageExperimentCache);
